import { Link } from 'react-router-dom';
import { dramas } from '@/mocks/dramas';
import DramaCard from '@/components/feature/DramaCard';
import SectionHeading from '@/components/base/SectionHeading';

const latest = [...dramas].sort((a, b) => b.updateDate.localeCompare(a.updateDate)).slice(0, 10);
const hot = [...dramas].sort((a, b) => b.popularity - a.popularity).slice(0, 6);

export default function HomeSections() {
  return (
    <>
      <section className="w-full px-4 md:px-10 py-12 md:py-16 bg-background-50">
        <SectionHeading
          eyebrow="New Arrivals"
          title="最新推荐"
          desc="收录近期上架的伦理题材剧集，按上线时间排序，方便快速了解新作的主创班底与故事梗概。"
          moreTo="/category/latest"
          moreLabel="全部新剧"
        />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {latest.map((drama) => (
            <DramaCard key={drama.id} drama={drama} />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-10 py-12 md:py-16 bg-background-100/70">
        <SectionHeading
          eyebrow="Most Watched"
          title="热门伦理剧精选"
          desc="依据站内热度整理的六部作品，多部聚焦家庭关系、婚姻抉择与代际沟通等现实议题。"
          moreTo="/category/ethics"
          moreLabel="伦理剧集"
        />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
          {hot.map((drama, index) => (
            <article
              key={drama.id}
              className="group flex gap-3.5 md:gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <Link to={`/detail/${drama.id}`} className="shrink-0 relative w-[92px] md:w-[110px]">
                <div className="w-[92px] h-[130px] md:w-[110px] md:h-[155px] rounded-md overflow-hidden bg-background-200">
                  <img
                    src={drama.poster}
                    alt={`${drama.title} 海报`}
                    title={`${drama.title} 伦理剧`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <span className="absolute -top-1.5 -left-1.5 w-7 h-7 rounded-md bg-primary-700 text-background-50 text-xs font-medium flex items-center justify-center">
                  {String(index + 1).padStart(2, '0')}
                </span>
              </Link>
              <div className="min-w-0 flex flex-col">
                <div className="flex items-center gap-2 mb-1">
                  <Link
                    to={`/detail/${drama.id}`}
                    className="font-heading text-[15px] md:text-base font-semibold text-foreground-950 truncate hover:text-primary-700 transition-colors"
                  >
                    {drama.title}
                  </Link>
                  <span className="shrink-0 flex items-center gap-0.5 text-[11px] text-accent-700">
                    <i className="ri-star-fill"></i>
                    {drama.rating.toFixed(1)}
                  </span>
                </div>
                <p className="text-[11px] text-foreground-500 mb-2">
                  {drama.year} · {drama.region} · {drama.status}
                </p>
                <p className="text-xs leading-6 text-foreground-600 line-clamp-3">{drama.summary}</p>
                <div className="mt-auto pt-2.5 flex items-center justify-between gap-2">
                  <span className="text-[11px] text-foreground-400 truncate">
                    导演 {drama.director}
                  </span>
                  <Link
                    to={`/detail/${drama.id}`}
                    className="h-7 px-3 rounded-md bg-primary-700 text-background-50 text-[11px] whitespace-nowrap flex items-center gap-1 hover:bg-primary-600 transition-colors"
                  >
                    详情
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}